module.exports = "/_next/static/images/new_success_alert-beb49763e7c46407e05097516f7ac1dd.png";